import { em, rem } from 'polished'
import styled from 'styled-components'

import { FileInfoStyled } from './FileInfoStyled'
import { MediaStyled } from '../../../elements/Media/styles/MediaStyled'

interface IFileStyledProps {
  border?: boolean
}

export const FileStyled = styled.div<IFileStyledProps>`
  width: 100%;
  border: ${(props) =>
    props.border ? `1px solid ${props.theme.colors.content.border}` : 'none'};
  padding: ${(props) => (props.border ? em(6) : 0)};

  display: flex;

  ${MediaStyled} {
    box-shadow: none;
  }

  ${FileInfoStyled} {
    margin-left: ${rem(12)};
  }
`
